import * as yup from "yup";

import { useState, useEffect, useCallback } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import ReactSelect from "./../../../components/common/ReactSelect";
import Toaster from "../../../components/common/Toaster";

import accountService from "../../../services/accountService";
import taxService from "./../../../services/taxService";

const schema = yup.object();

const AccountRDOFilter = ({ options, onFilter }) => {
  const [rdos, setRdos] = useState([]);

  const statuses = accountService.getAccountStatuses();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleReset = () => {
    const status = "";
    const rdo = "";

    onFilter(status, rdo);
  };

  const onSubmit = (info) => {
    const rdo = info.rdo && info.rdo.value !== undefined ? info.rdo.value : "";
    const status =
      info.status && info.status.value !== undefined ? info.status.value : "";

    onFilter(status, rdo);
  };

  const fetchRdos = useCallback(async (mounted) => {
    try {
      const result = await taxService.getRevenueDistrictOfficesAsync();

      const options = result.map((item) => {
        const option = {};
        option["label"] = item;
        option["value"] = item;

        return option;
      });

      if (mounted) setRdos(options);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  }, []);

  useEffect(() => {
    let mounted = true;

    fetchRdos(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchRdos]);

  useEffect(() => {
    if (options) {
      const { rdo, status } = options;

      const statuses = accountService.getAccountStatuses();
      const selected_status = statuses.filter((i) => i.value === status);
      const selected_rdo = rdo ? { label: rdo, value: rdo } : null;

      setValue("rdo", selected_rdo);
      setValue("status", selected_status);
    }
  }, [options, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="status-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="rdo-dropdown"
            name="rdo"
            title="RDO"
            options={rdos}
            control={control}
            register={register("rdo")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default AccountRDOFilter;
